import enCompanyStatistic from './en';
import ruCompanyStatistic from './ru';

export default {
  en: {
    ...enCompanyStatistic,
  },
  ru: {
    ...ruCompanyStatistic,
  },
};
